// extracted by mini-css-extract-plugin
module.exports = {"Result":"Result_Result__oPSbP","Cards":"Result_Cards__9yYuk","RightSide":"Result_RightSide__yMBUI","Text":"Result_Text__2A_gf","CardsTitle":"Result_CardsTitle__11B1n"};